import React from 'react';
import ReactDOM from 'react-dom';
import { ArticleFromDom } from './Types';
import AddToCart from '../../Components/Cart/Components/AddToCart/AddToCart';

const integrationContainers = document.querySelectorAll('.js-premium-program-actions') as NodeListOf<HTMLElement>;

interface PremiumProgramProps {
    article: ArticleFromDom;
}
const PremiumProgram: React.FunctionComponent<PremiumProgramProps> = (props) => {
    return (
        <div className="premium-program-actions">
            <AddToCart article={props.article} />
        </div>
    );
};

const PremiumIntegration: React.FunctionComponent = () => {
    if (integrationContainers.length > 0) {
        return (
            <>
                {[...integrationContainers].map((container) => {
                    const productData: ArticleFromDom = JSON.parse(container.dataset.article as string);
                    return ReactDOM.createPortal(<PremiumProgram article={productData} />, container);
                })}
            </>
        );
    }

    return null;
};

export default PremiumIntegration;
